import "./styles.scss"
import {
  FormGroup,
  FormRow,
  Input,
  Label,
  SelectInput,
  SelectInputCreatable,
} from "../../components/Form"
import { Button } from "../../components/Button"

const CodesValuesScreen = ({
  esmId,
  codesValues,
  values,
  codesSelect,
  removeCodes,
  handleChangeCodes,
  handleChangeInputCodesSelect,
  addCodes,
  notReturn,
  filterQuestionsByCode,
  resetFields,
  isPro
}) => {
  return (
    <div
      className={`${
        esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
          ? "container-fields-esm"
          : "container-fields"
      }`}>
      <div className="button-add-field">
        <Button
          label="Adicionar código e valor"
          color="orange"
          variant="ghost"
          handleClick={addCodes}
        />
      </div>
      <div className="codes-fields">
        {codesValues?.map((el, index) => (
          <FormRow key={index + 1}>
            <div>
              <div className={`${el?.type?.includes("select") ? "select-form" : "form-box"}`}>
                {el.code !== undefined && (
                  <div className="form-date">
                    <Label label={`Código ${index + 1}`} />
                    <Input
                      name="code"
                      value={el?.code}
                      onChange={(e) => handleChangeCodes(index, e)}
                      // hasError={notReturn && notReturn.find(item => item.code === el?.code) && "Sem valor encontrado"}
                    />
                  </div>
                )}
                {el.code === undefined && el.id !== undefined && (
                  <div className="form-date questions-name">
                    <Label label={`${el?.name}`} />
                    {/* <Input
                name="questionId"
                isDisabled
                value={el?.name}
                onChange={(e) => handleChangeCodes(index, e)}
                // hasError={notReturn && notReturn.find(item => item.code === el?.code) && "Sem valor encontrado"}
              /> */}
                  </div>
                )}
                <div className="form-date values-fields">
                  {el.id === undefined && <Label label={`Valor ${index + 1}`} />}
                  {el.id === undefined && (
                    <Input
                      name="value"
                      value={el?.value}
                      onChange={(e) => handleChangeCodes(index, e)}
                    />
                  )}
                  {el.id !== undefined && el.type === "select-creatable" && (
                    <SelectInputCreatable
                      name="codes"
                      resetFields={resetFields}
                      onChange={(field, e) => handleChangeCodes(field, e, el.id)}
                      isSearchable={true}
                      options={filterQuestionsByCode[0][el.id]}
                      onInputChange={(e, action) => handleChangeInputCodesSelect(e, action, el.id)}
                      defaultValue={values
                        ?.filter((item) => item.code === el.id)
                        .map(({ code, value, label }) => ({ label, value }))}
                      isOverModal={true}
                      isMulti={true}
                      menuShouldBlockScroll={true}
                    />
                  )}
                  {el.id !== undefined && el.type === "select" && (
                    <SelectInput
                      name="codes"
                      resetFields={resetFields}
                      onChange={(field, e) => handleChangeCodes(field, e, el.id)}
                      isSearchable={true}
                      options={filterQuestionsByCode[0][el.id]}
                      defaultValue={values
                        ?.filter((item) => item.code === el.id)
                        .map(({ code, value, label }) => ({ label, value }))}
                      isOverModal={true}
                      isMulti={el?.isMulti}
                      menuShouldBlockScroll={true}
                    />
                  )}
                </div>
                {codesValues.length > 0 && !el?.id && (
                  <div className="button-remove-form">
                    <button onClick={() => removeCodes(index, el.id)}>
                      <i className="fi fi-ss-trash"></i>
                    </button>
                  </div>
                )}
              </div>
            </div>
          </FormRow>
        ))}
      </div>
    </div>
  )
}

export default CodesValuesScreen
